import React, { useState } from "react";
import { Button, Box } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Papa from "papaparse";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";

export default function UploadProgram() {
  const [previewData, setPreviewData] = useState([]);
  const [csvFile, setCsvFile] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const columns = [
    { field: "sno", headerName: "S.No", width: 80 },
    { field: "program_name", headerName: "Program Name", flex: 1 },
    { field: "college_id", headerName: "College ID", flex: 1 },
    { field: "program_duration", headerName: "Duration", flex: 1 },
    {
      field: "errors",
      headerName: "Errors",
      flex: 2,
      renderCell: (params) => (
        <span style={{ color: "red" }}>
          {params.value && params.value.length > 0 ? params.value.join(", ") : ""}
        </span>
      ),
    },
  ];

  const handleFileChange = (e) => {
    setCsvFile(e.target.files[0]);
  };

  const handlePreview = () => {
    if (!csvFile) return;

    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        const validatedData = results.data.map((row, index) => {
          let errors = [];
          if (!row.program_name) errors.push("Program Name missing");
          if (!row.college_id || isNaN(row.college_id)) errors.push("Invalid College ID");
          if (!row.program_duration || isNaN(row.program_duration)) errors.push("Invalid Duration");

          return {
            id: index + 1, // DataGrid row ID
            sno: index + 1, // Serial number for table
            ...row,
            errors,
          };
        });
        setPreviewData(validatedData);
      },
    });
  };

  const handleConfirm = async () => {
    try {
      const validRows = previewData.filter((row) => !row.errors || row.errors.length === 0);

      const res = await axios.post(
        `${API_BASE_URL}/api/programs/upload-programs-confirm/${user.client_id}`,
        { programs: validRows }
      );

      alert(res.data.message || "Uploaded successfully");
    } catch (err) {
      console.error(err);
      alert("Error uploading data: " + (err.response?.data?.message || err.message));
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* File upload */}
      <input
        type="file"
        accept=".csv"
        style={{ display: "none" }}
        id="upload-csv"
        onChange={handleFileChange}
      />
      <label htmlFor="upload-csv">
        <Button
          variant="contained"
          component="span"
          startIcon={<CloudUploadIcon />}
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            "&:hover": { backgroundColor: "#115293" },
          }}
        >
          Choose CSV File
        </Button>
      </label>

      <Button
        sx={{
          ml: 2,
          backgroundColor: "#ff9800",
          color: "#fff",
          "&:hover": { backgroundColor: "#c77700" },
        }}
        variant="contained"
        onClick={handlePreview}
      >
        Preview
      </Button>

      {/* DataGrid preview */}
      {previewData.length > 0 && (
        <>
          <Box sx={{ mt: 3, height: 400 }}>
            <DataGrid
              rows={previewData}
              columns={columns}
              autoHeight
              pageSize={pageSize} // controlled pageSize
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} // update state
              rowsPerPageOptions={[5, 10, 25, 50]}
              disableRowSelectionOnClick
              pagination
            />
          </Box>

          <Button
            sx={{
              mt: 2,
              backgroundColor: "#4caf50",
              color: "#fff",
              "&:hover": { backgroundColor: "#357a38" },
            }}
            variant="contained"
            onClick={handleConfirm}
          >
            Confirm & Upload
          </Button>
        </>
      )}
    </Box>
  );
}
